import nsUtils from '@netsapiens/netsapiens-js/dist/utils';

import { store } from '../store';

export default () => (phoneNumber) => {
  const countryCode = store.getState().configs.get('countryCode');
  return nsUtils.formatPhoneNumber(phoneNumber, countryCode);
};
